import {
  useState,
  useEffect,
  useCallback,
  createContext,
  useContext
} from "react"
import Container from "./container"

function useForceUpdate() {
  const [, setState] = useState({})

  const forceUpdate = useCallback(() => setState({}), [])

  return forceUpdate
}

export const ContainerContext = createContext()

/**
 * A helper hook to create the container state object that handles
 * rerendering when the container changes.
 */
export function useContainerState(containerOptions) {
  const forceUpdate = useForceUpdate()
  const [container] = useState(() => Container(containerOptions))

  useEffect(() => {
    container.subscribe(forceUpdate)
  }, [container, forceUpdate])

  return container
}

function useContainer() {
  return useContext(ContainerContext)
}

export default useContainer
